<template>
	<div class="product-list">
    <div class="product-list-header" @click="productListClick(items)">
      <span class="header-title">{{title}}</span>
    </div>
    <div class="product-list-body">
      <img v-bind:style="getBannerStyle" :src="items.photo" alt="" @click="productListClick(items)"  srcset="">
      <!-- <home-product-body v-for='(item, index) in dataList'  :item="item" :index="index"  v-if="index<items.display_goods_numbers"  :key='index'></home-product-body> -->
      <topic-product-body v-for='(item, index) in dataList'  :item="item" :index="index" :cartAddType="cartAddType" v-if="index<items.display_goods_numbers"  :key='index'></topic-product-body>
      <img  v-if="items.display_goods_numbers>0 && dataList.length >=items.display_goods_numbers" v-bind:style="getProductStyle"   @click="productListClick(items)" :src="more">
    </div>
  </div>
</template>

<script>
import { Header, Indicator, Toast } from 'mint-ui';
import HomeProductBody from './HomeProductBody';
import TopicProductBody from '../../topic/child/TopicProductBody';
import { mapState, mapMutations, mapActions } from 'vuex';
import more from '@/assets/image/home/more.jpg'

export default {
  name: 'HomeProductList',
  data() {
    return {
      more,
      dataList:[],
      cartAddType: 3
    };
  },
  props: ['items', 'title', 'type','id'],
  components: {
    HomeProductBody,
    TopicProductBody
  },
  mounted(){
    if(!this.dataList || this.dataList.length <1){
      this.fetchTopicProductList({topic_id:this.id,page:1,per_page:this.items.display_goods_numbers}).then(
        response => {
          this.dataList = response.dataList;
          this.cartAddType = response.cart_add_type || 3;
        },
        error => {
          console.dir(error)
        }
      )
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,         
      config: state => state.config.config,    
      banners: state => state.home.banners,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts
    }),
    getProductStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width / 3 - 40 - 1;
      let itemHeight = itemWidth * (132.0 / 94.0) -10;
      return {
        'padding-top':'10px',
        'padding-left':'10px',
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = width * (74.0 / 188.0)//(94.0 / 188.0)
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
  },
  methods: {
    ...mapMutations({
      saveToken: 'saveToken'
    }),
    ...mapActions({
      fetchTopicProductList: 'fetchTopicProductList'
    }),
    productListClick: function(items) {
      this.$router.push({
        name: 'topic',
        query: { tid: items.id ,display_area:2}
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  background: #FFFFFF;
  margin-top: 0px;
  margin-bottom: 12px;
  border-top: 2px #eeeeee solid;
  margin-bottom: 0px;
  .product-list-header {
    display: flex;
    height: 40px;
    padding: 0px 5px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    .header-title {
      margin-left: 10px;
      padding-left:10px;
      border-left: 2px #f17100 solid;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
    }
    .header-icon {
      width: 20px;
      height: 20px;
    }
  }
  .product-list-body {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/promotion-list/child/HomeProductList.vue